import { DataSource } from '@/shared/models/data/data-source'
import { Post } from '@/business/post/models/post'
import { Injector } from '@/config/dependency-injection'
import { PageResponse } from '@/shared/interfaces/page-response'
import { SearchRequest } from '@/shared/interfaces/search-request'
import { PostUpdate } from '@/business/post/models/post-update'
import { ProjectModule } from '@/business/project/store/project-module'
import { LoaderHelper } from '@/shared/services/loader-helper'
import { FETCH_PROJECT_POSTS } from '@/business/project/store/types'
import { ProjectViewModel } from '@/business/project/interfaces/project-view-model'

export class ProjectPostDataSource extends DataSource<Post> {
  private loaderHelper = Injector.get(LoaderHelper)
  private projectModule = Injector.get(ProjectModule)

  public get items(): Post[] {
    return this.projectModule.data.project.posts.items
  }

  private get posts(): PageResponse<Post> {
    return this.project.posts
  }

  private get project(): ProjectViewModel {
    return this.projectModule.data.project
  }

  public destroy(): void {
    //
  }

  public fetchData({ page, pageSize }: SearchRequest): Promise<PageResponse<Post>> {
    return this.projectModule.fetchProjectPosts({
      projectId: this.project.id,
      page,
      pageSize,
    })
  }

  public hasMorePosts(): boolean {
    return this.posts.total > this.posts.size
  }

  public isLoading(): boolean {
    return this.loaderHelper.isLoading(FETCH_PROJECT_POSTS)
  }

  public createPost(post: PostUpdate) {
    return this.projectModule.createProjectPost({
      projectId: this.project.id,
      post,
    })
  }

  public deletePost(post: Post) {
    return this.projectModule.deleteProjectPost({
      post,
    })
  }

  public updatePost(post: Post) {
    return this.projectModule.updateProjectPost({
      postId: post.id,
      post,
    })
  }
}
